import { render } from "./TicketDetailView.vue?vue&type=template&id=643a2ccd&scoped=true"
import script from "./TicketDetailView.vue?vue&type=script&lang=js"
export * from "./TicketDetailView.vue?vue&type=script&lang=js"

import "./TicketDetailView.vue?vue&type=style&index=0&id=643a2ccd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-643a2ccd"]])

export default __exports__